/* tslint:disable */
/* eslint-disable */
export enum CashFundOrigin {
  Standard = 0,
  Whitelist = 1,
  Recurring = 2,
}
